import { Component, signal, WritableSignal } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth.service';
import { DialogService } from '@app/lib/services/dialog.service';
import { VersionService } from '@app/version/version';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';
import { TAny } from '@app/lib/models/common.type';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [MatFormFieldModule,
          MatInputModule,
          MatButtonModule,
          ReactiveFormsModule,
          MatIconModule,],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
   public toggleShowoldPwd: WritableSignal<boolean> = signal(false);
     public toggleShowNewPwd: WritableSignal<boolean> = signal(false);
     public toggleShowConfirmPwd: WritableSignal<boolean> = signal(false);
      version: string | null = null;
      buildTime: string | null = null;
      formattedBuildTime: string = '';
    
      constructor(
        private dialog: MatDialog,
        private authService: AuthService,
        private dialogService: DialogService,
        private router: Router,
      ) { }
    
      resetForm: FormGroup = new FormGroup({
        userName: new FormControl('', Validators.required),
        email: new FormControl('', [Validators.required, Validators.email]),
      });
  
  
     
      
    
      ngOnInit(): void {
    
      }
    
      formatBuildTime(): void {
        if (this.buildTime) {
          const date = new Date(this.buildTime);
          this.formattedBuildTime = date.toLocaleString(); // Customize this format as needed
        }
      }
    
      
      onReset(): void {
        this.router.navigate(['/login']);
      }
    
      onSubmit(): void {
        if (this.resetForm.invalid) {
          this.resetForm.markAllAsTouched();
      
          if (this.resetForm.get('userName')?.hasError('required')) {
            this.dialogService.openDialog1( {
              data: {
                title: 'Validation Error',
                message: 'Username is required.',
                icon: 'error',
              }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
            });
            return;
          }
      
          const emailCtrl = this.resetForm.get('email');
          if (emailCtrl?.hasError('required')) {
            this.dialogService.openDialog1( {
              data: {
                title: 'Validation Error',
                message: 'Email is required.',
                icon: 'error',
              }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
            });
            return;
          }
      
          if (emailCtrl?.hasError('email')) {
            this.dialogService.openDialog1( {
              data: {
                title: 'Validation Error',
                message: 'Please enter a valid email address.',
                icon: 'error',
              }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
            });
            return;
          }
      
          return;
        }
      
        const formValues = this.resetForm.value;
        const userName = formValues.userName;
        const email = formValues.email;
        
       
  
         this.authService.forgotPassword(userName, email).subscribe({
              next: (res: TAny) => {
                if(res.success){
                  const dialogRef = this.dialogService.openDialog1( {
                    data: {
                      title: 'Success',
                      message: res.success,
                      icon: 'check_small'
                    }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
                  });
                
                  dialogRef.afterClosed().subscribe(() => {
                    this.authService.logout()
                    // 👇 Replace '/target-route' with your actual route
                    this.router.navigate(['/login']);
                  });
                }else if(res.failure){
                  this.dialogService.openDialog1( {
                    data: {
                      title: 'Error',
                      message:res.failure,
                      icon:'error', // ✅ Default icon if not provided
                    }, disableClose: true,           // Prevents closing on outside click or ESC
  hasBackdrop: true,            // Shows backdrop to block interaction
  backdropClass: 'dialog-backdrop', // Optional: custom styling
                  });
  
                }
              },
              error: (err) => {
                console.error('Error fetching document types:', err);
              }
            });
  
  }

}
